import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Button } from '@/components/ui/button';
import { Paperclip } from 'lucide-react';
import { cn } from '@/lib/utils';
const DroppedFilesList = ({
  droppedFiles
}) => <div className="text-xs text-muted-foreground flex gap-1 mt-1">
    {droppedFiles.map(file => <span key={file.name} className="bg-muted px-1.5 py-0.5 rounded truncate max-w-[100px]">
        {file.name}
      </span>)}
  </div>;
const AttachDialogHeader = ({
  droppedFiles
}) => <DialogHeader className="p-4 pb-0">
    <DialogTitle className="flex items-center gap-2">
      <Paperclip className="h-4 w-4 text-primary" />
      <span>Attach files to...</span>
    </DialogTitle>
    <DroppedFilesList droppedFiles={droppedFiles} />
  </DialogHeader>;
const AttachTodoItem = ({
  todo,
  onSelectTodo
}) => <CommandItem key={todo.id} data-todo-id={todo.id} value={todo.id} onSelect={onSelectTodo} className="flex items-center gap-2 cursor-pointer">
    <div className={cn('h-2 w-2 rounded-full', todo.completed ? 'bg-primary' : 'bg-muted-foreground/50')} />
    <span className="truncate flex-1">{todo.text || 'Untitled Task'}</span>
    {todo.status && <span className="text-[10px] uppercase tracking-wider opacity-50 font-bold bg-muted px-2 py-0.5 rounded">
        {todo.status}
      </span>}
  </CommandItem>;
const AttachTodoList = ({
  todos,
  onSelectTodo
}) => <CommandList className="max-h-[300px]">
    <CommandEmpty>No tasks found.</CommandEmpty>
    <CommandGroup heading="Recent Tasks">
      {todos.slice(0, 10).map(todo => <AttachTodoItem key={todo.id} todo={todo} onSelectTodo={onSelectTodo} />)}
    </CommandGroup>
  </CommandList>;
const AttachCommand = ({
  todos,
  onSelectTodo
}) => <Command className="rounded-xl border-none">
    <CommandInput placeholder="Search..." />
    <AttachTodoList todos={todos} onSelectTodo={onSelectTodo} />
  </Command>;
export function AttachFileDialog({
  isOpen,
  onOpenChange,
  droppedFiles,
  todos,
  onSelectTodo,
  onCancel
}) {
  return <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] p-0 overflow-hidden border-none shadow-2xl">
        <AttachDialogHeader droppedFiles={droppedFiles} />
        <AttachCommand todos={todos} onSelectTodo={onSelectTodo} />
        <div className="p-4 border-t bg-muted/50 flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>;
}
